// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resources-menu-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(18, 16, 26, 0.52);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.resources-menu-dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 1380px);
  height: min(94vh, 980px);
  max-height: min(94vh, 980px);
  background: #fff;
  color: #1f1b2e;
  border: 1px solid rgba(31, 27, 46, 0.1);
  border-radius: 22px;
  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.28);
  overflow: hidden;
}

.resources-menu-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.2rem 1.5rem 0.95rem;
  border-bottom: 1px solid rgba(31, 27, 46, 0.08);
  flex-shrink: 0;
}

.resources-menu-dialog__eyebrow {
  margin: 0 0 0.25rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #55515f;
}

.resources-menu-dialog__title {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.4rem, 2.4vw, 1.85rem);
  font-weight: 700;
  letter-spacing: -0.015em;
  line-height: 1.2;
  color: #1f1b2e;
}

.resources-menu-dialog__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.35rem;
  height: 2.35rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(31, 27, 46, 0.12);
  border-radius: 999px;
  background: #f4f2f8;
  color: #1f1b2e;
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.15s ease;
}

.resources-menu-dialog__close:hover {
  background: #ebe8f2;
  transform: translateY(-1px);
}

.resources-menu-dialog__tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  padding: 0.85rem 1.5rem;
  border-bottom: 1px solid rgba(31, 27, 46, 0.08);
  background: #fbfbfd;
  flex-shrink: 0;
}

.resources-menu-dialog__tab {
  margin: 0;
  padding: 0.48rem 0.95rem;
  border: 1px solid rgba(31, 27, 46, 0.1);
  border-radius: 999px;
  background: #fff;
  color: #403b55;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;
}

.resources-menu-dialog__tab:hover {
  background: #f4f2f8;
}

.resources-menu-dialog__tab.is-active {
  background: #d5d1fd;
  border-color: #d5d1fd;
  color: #1f1b2e;
}

.resources-menu-dialog__tabs > .resources-menu-dialog__tab:first-child.is-active {
  background: #bff1db;
  border-color: #bff1db;
  color: #355c4a;
}

.resources-menu-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 1.15rem 1.5rem 1.5rem;
  -webkit-overflow-scrolling: touch;
}

.resources-menu-dialog__columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem 1.75rem;
  align-items: start;
  min-height: 100%;
}

.resources-menu-dialog__column {
  min-width: 0;
  padding: 1rem 1.1rem 1.15rem;
  border: 1px solid rgba(31, 27, 46, 0.08);
  border-radius: 16px;
  background: #fbfbfd;
}

.resources-menu-dialog__level {
  margin: 0 0 0.85rem;
  padding-bottom: 0.55rem;
  border-bottom: 1px solid rgba(31, 27, 46, 0.1);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #55515f;
}

.resources-menu-dialog__empty {
  margin: 0.35rem 0 0;
  color: #77718b;
  font-size: 0.92rem;
  line-height: 1.45;
}

.resources-menu__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.resources-menu__list--depth-1,
.resources-menu__list--depth-2,
.resources-menu__list--depth-3 {
  margin-top: 0.4rem;
  margin-left: 0.35rem;
  padding-left: 0.85rem;
  border-left: 2px solid rgba(213, 209, 253, 0.85);
}

.resources-menu__item {
  margin: 0;
  scroll-margin-top: 12px;
}

.resources-menu__item + .resources-menu__item {
  margin-top: 0.35rem;
}

.resources-menu__item--subject {
  padding: 0.15rem;
  border-radius: 14px;
  transition: background-color 0.35s ease, box-shadow 0.35s ease;
}

.resources-menu__item--subject.is-flash {
  background: rgba(213, 209, 253, 0.45);
  box-shadow: inset 0 0 0 1px #d5d1fd;
}

.resources-menu__list--depth-0 > .resources-menu__item--branch > .resources-menu__branch {
  font-size: 1.05rem;
  font-weight: 800;
  padding: 0.55rem 0.45rem;
}

.resources-menu__list--depth-0 > .resources-menu__item + .resources-menu__item {
  margin-top: 0.55rem;
}

.resources-menu__branch {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  margin: 0;
  padding: 0.45rem 0.4rem;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #1f1b2e;
  font-weight: 700;
  font-size: 1rem;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.resources-menu__branch:hover {
  background: rgba(213, 209, 253, 0.28);
}

.resources-menu__branch-label {
  flex: 1 1;
  min-width: 0;
}

.resources-menu__chevron {
  width: 0.45rem;
  height: 0.45rem;
  flex-shrink: 0;
  border-right: 2px solid #55515f;
  border-bottom: 2px solid #55515f;
  transform: rotate(-45deg);
  transition: transform 0.2s ease;
}

.resources-menu__item--branch.is-open > .resources-menu__branch .resources-menu__chevron {
  transform: rotate(45deg);
}

.resources-menu__link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  padding: 0.55rem 0.7rem;
  border: 1px solid rgba(31, 27, 46, 0.1);
  border-radius: 12px;
  background: #fff;
  color: #1f1b2e;
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.35;
  text-decoration: none;
  box-shadow: 0 1px 0 rgba(31, 27, 46, 0.03);
  transition: background-color 0.15s ease, border-color 0.15s ease,
    transform 0.12s ease;
}

.resources-menu__link:hover {
  background: #d5d1fd;
  border-color: #d5d1fd;
  color: #1f1b2e;
  transform: translateY(-1px);
}

.resources-menu__link--prominent {
  padding: 0.85rem 1rem;
  font-size: 1.02rem;
  font-weight: 700;
  background: #fff;
  border-color: #d5d1fd;
}

.resources-menu__link-text {
  min-width: 0;
  text-align: left;
}

.resources-menu__link-meta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 999px;
  background: #bff1db;
  color: #355c4a;
}

.resources-menu__link-meta i {
  font-size: 0.72rem;
}

.resources-menu__link:hover .resources-menu__link-meta {
  background: #fff;
  color: #403b55;
}

@media (max-width: 900px) {
  .resources-menu-dialog__columns {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .resources-menu-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .resources-menu-dialog {
    width: 100%;
    height: min(96vh, 980px);
    max-height: min(96vh, 980px);
    border-radius: 20px 20px 0 0;
  }

  .resources-menu-dialog__header,
  .resources-menu-dialog__tabs,
  .resources-menu-dialog__body {
    padding-left: 1.1rem;
    padding-right: 1.1rem;
  }

  .resources-menu-dialog__tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }

  .resources-menu-dialog__tab {
    flex: 0 0 auto;
  }
}

@media (prefers-reduced-motion: reduce) {
  .resources-menu-dialog__close,
  .resources-menu-dialog__tab,
  .resources-menu__chevron,
  .resources-menu__branch,
  .resources-menu__link {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ResourcesMenuDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,8BAA8B;EAC9B,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,wCAAwC;EACxC,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,+CAA+C;EAC/C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,uCAAuC;EACvC,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;oBACkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8DAA8D;AAChE;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,0CAA0C;EAC1C;wBACsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,wBAAwB;IACxB,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;;;IAGE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;;;;;IAKE,gBAAgB;EAClB;AACF","sourcesContent":[".resources-menu-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: rgba(18, 16, 26, 0.52);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.resources-menu-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(100%, 1380px);\n  height: min(94vh, 980px);\n  max-height: min(94vh, 980px);\n  background: #fff;\n  color: #1f1b2e;\n  border: 1px solid rgba(31, 27, 46, 0.1);\n  border-radius: 22px;\n  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.28);\n  overflow: hidden;\n}\n\n.resources-menu-dialog__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.2rem 1.5rem 0.95rem;\n  border-bottom: 1px solid rgba(31, 27, 46, 0.08);\n  flex-shrink: 0;\n}\n\n.resources-menu-dialog__eyebrow {\n  margin: 0 0 0.25rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #55515f;\n}\n\n.resources-menu-dialog__title {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.4rem, 2.4vw, 1.85rem);\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  line-height: 1.2;\n  color: #1f1b2e;\n}\n\n.resources-menu-dialog__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.35rem;\n  height: 2.35rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  border-radius: 999px;\n  background: #f4f2f8;\n  color: #1f1b2e;\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.15s ease;\n}\n\n.resources-menu-dialog__close:hover {\n  background: #ebe8f2;\n  transform: translateY(-1px);\n}\n\n.resources-menu-dialog__tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  padding: 0.85rem 1.5rem;\n  border-bottom: 1px solid rgba(31, 27, 46, 0.08);\n  background: #fbfbfd;\n  flex-shrink: 0;\n}\n\n.resources-menu-dialog__tab {\n  margin: 0;\n  padding: 0.48rem 0.95rem;\n  border: 1px solid rgba(31, 27, 46, 0.1);\n  border-radius: 999px;\n  background: #fff;\n  color: #403b55;\n  font-size: 0.9rem;\n  font-weight: 700;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.resources-menu-dialog__tab:hover {\n  background: #f4f2f8;\n}\n\n.resources-menu-dialog__tab.is-active {\n  background: #d5d1fd;\n  border-color: #d5d1fd;\n  color: #1f1b2e;\n}\n\n.resources-menu-dialog__tabs > .resources-menu-dialog__tab:first-child.is-active {\n  background: #bff1db;\n  border-color: #bff1db;\n  color: #355c4a;\n}\n\n.resources-menu-dialog__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 1.15rem 1.5rem 1.5rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n.resources-menu-dialog__columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.25rem 1.75rem;\n  align-items: start;\n  min-height: 100%;\n}\n\n.resources-menu-dialog__column {\n  min-width: 0;\n  padding: 1rem 1.1rem 1.15rem;\n  border: 1px solid rgba(31, 27, 46, 0.08);\n  border-radius: 16px;\n  background: #fbfbfd;\n}\n\n.resources-menu-dialog__level {\n  margin: 0 0 0.85rem;\n  padding-bottom: 0.55rem;\n  border-bottom: 1px solid rgba(31, 27, 46, 0.1);\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #55515f;\n}\n\n.resources-menu-dialog__empty {\n  margin: 0.35rem 0 0;\n  color: #77718b;\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.resources-menu__list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.resources-menu__list--depth-1,\n.resources-menu__list--depth-2,\n.resources-menu__list--depth-3 {\n  margin-top: 0.4rem;\n  margin-left: 0.35rem;\n  padding-left: 0.85rem;\n  border-left: 2px solid rgba(213, 209, 253, 0.85);\n}\n\n.resources-menu__item {\n  margin: 0;\n  scroll-margin-top: 12px;\n}\n\n.resources-menu__item + .resources-menu__item {\n  margin-top: 0.35rem;\n}\n\n.resources-menu__item--subject {\n  padding: 0.15rem;\n  border-radius: 14px;\n  transition: background-color 0.35s ease, box-shadow 0.35s ease;\n}\n\n.resources-menu__item--subject.is-flash {\n  background: rgba(213, 209, 253, 0.45);\n  box-shadow: inset 0 0 0 1px #d5d1fd;\n}\n\n.resources-menu__list--depth-0 > .resources-menu__item--branch > .resources-menu__branch {\n  font-size: 1.05rem;\n  font-weight: 800;\n  padding: 0.55rem 0.45rem;\n}\n\n.resources-menu__list--depth-0 > .resources-menu__item + .resources-menu__item {\n  margin-top: 0.55rem;\n}\n\n.resources-menu__branch {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  margin: 0;\n  padding: 0.45rem 0.4rem;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: #1f1b2e;\n  font-weight: 700;\n  font-size: 1rem;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.resources-menu__branch:hover {\n  background: rgba(213, 209, 253, 0.28);\n}\n\n.resources-menu__branch-label {\n  flex: 1;\n  min-width: 0;\n}\n\n.resources-menu__chevron {\n  width: 0.45rem;\n  height: 0.45rem;\n  flex-shrink: 0;\n  border-right: 2px solid #55515f;\n  border-bottom: 2px solid #55515f;\n  transform: rotate(-45deg);\n  transition: transform 0.2s ease;\n}\n\n.resources-menu__item--branch.is-open > .resources-menu__branch .resources-menu__chevron {\n  transform: rotate(45deg);\n}\n\n.resources-menu__link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.55rem 0.7rem;\n  border: 1px solid rgba(31, 27, 46, 0.1);\n  border-radius: 12px;\n  background: #fff;\n  color: #1f1b2e;\n  font-weight: 600;\n  font-size: 0.95rem;\n  line-height: 1.35;\n  text-decoration: none;\n  box-shadow: 0 1px 0 rgba(31, 27, 46, 0.03);\n  transition: background-color 0.15s ease, border-color 0.15s ease,\n    transform 0.12s ease;\n}\n\n.resources-menu__link:hover {\n  background: #d5d1fd;\n  border-color: #d5d1fd;\n  color: #1f1b2e;\n  transform: translateY(-1px);\n}\n\n.resources-menu__link--prominent {\n  padding: 0.85rem 1rem;\n  font-size: 1.02rem;\n  font-weight: 700;\n  background: #fff;\n  border-color: #d5d1fd;\n}\n\n.resources-menu__link-text {\n  min-width: 0;\n  text-align: left;\n}\n\n.resources-menu__link-meta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 1.7rem;\n  height: 1.7rem;\n  border-radius: 999px;\n  background: #bff1db;\n  color: #355c4a;\n}\n\n.resources-menu__link-meta i {\n  font-size: 0.72rem;\n}\n\n.resources-menu__link:hover .resources-menu__link-meta {\n  background: #fff;\n  color: #403b55;\n}\n\n@media (max-width: 900px) {\n  .resources-menu-dialog__columns {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .resources-menu-overlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .resources-menu-dialog {\n    width: 100%;\n    height: min(96vh, 980px);\n    max-height: min(96vh, 980px);\n    border-radius: 20px 20px 0 0;\n  }\n\n  .resources-menu-dialog__header,\n  .resources-menu-dialog__tabs,\n  .resources-menu-dialog__body {\n    padding-left: 1.1rem;\n    padding-right: 1.1rem;\n  }\n\n  .resources-menu-dialog__tabs {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n  }\n\n  .resources-menu-dialog__tab {\n    flex: 0 0 auto;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .resources-menu-dialog__close,\n  .resources-menu-dialog__tab,\n  .resources-menu__chevron,\n  .resources-menu__branch,\n  .resources-menu__link {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
